export default __webpack_public_path__ + "static/media/search-9a714042e3795240774eb50029e64e51.png";